<!-- <button (click)="toggleSideNav()" class="side-nav-toggle">☰</button> -->


<div *ngIf="isSideNavOpen" (click)="onSideNavClick($event)" class="side-nav">
    <!-- <div class="half-circle" (click)="closeSideNav()"></div> -->
    <ul>
        <li *ngFor="let step of steps; let i = index"  class="breadcrumb-item" [class.active]="step.active" [class.non-active]="!step.active" (click)="step.active?onStepClick(i):showNonActiveFeedback($event)">
        <div class="circle">{{ i + 1 }}</div>
        <div class="label">{{ step.label }}</div>
        <div *ngIf="i < steps.length - 1" class="connector" [ngClass]="{'selected-connector':isConnectorActive(i+1)}"></div>
        </li>
    </ul>
</div>

